import React from 'react'
import {useSupplierFormItem} from "../providers/SupplierFormItemProvider";
import {FormInputComponent} from "../../../components/form/Form";

const SupplierCertificationForm = (props) => {

    const {
        profileItem,
        profileIndex,
        onModelChange,
        refresh,
        isEditing,
        yearOptions
    } = useSupplierFormItem()

    return (
        <div className="flex flex-col">
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-5/12">
                    <FormInputComponent
                        fieldName="name"
                        value={profileItem.name || ''}
                        type="text"
                        label={TB.trans('talent.certification_form.certification_name_label')}
                        maxLength={255}
                        required={true}
                        placeholder={TB.trans('talent.certification_form.certification_name_placeholder')}
                        style={styles.field}
                    />
                </div>
            </div>
            {(isEditing || profileItem.earned_at) && (

                <div className="field-section flex-row">
                        <div className="field px-3.5 basis-5/12">
                            <FormInputComponent
                                fieldName="earned_at"
                                value={profileItem.earned_at || ''}
                                label="Date Achieved"
                                placeholder="--/--/----"
                                type="date"
                                required={true}
                                style={styles.field}
                            />
                        </div>
                </div>
            )}
            {(isEditing || profileItem.logo_path) && (
                <div className="field-section flex-row">
                    <div className="field px-3.5 basis-8/12">
                        <FormInputComponent
                            fieldName="logo_path"
                            value={profileItem.logo_path || ''}
                            label={TB.trans('talent.certification_form.certification_logo_label')}
                            type="pixie"
                            ratio="1:1"
                            required={false}
                            style={styles.field}
                        />
                    </div>
                </div>
            )}

            {(isEditing || profileItem.description) && (
                <div className="field-section flex-row">
                    <div className="field px-3.5 basis-8/12">
                        <FormInputComponent
                            fieldName="description"
                            value={profileItem.description || ''}
                            label={TB.trans('talent.certification_form.certification_summary_label')}
                            placeholder={TB.trans('talent.certification_form.certification_summary_placeholder')}
                            type={'editor'}
                            required={false}
                            style={styles.field}
                            maxLength={10000}
                            rows={10}
                            validation={{
                                rules: {maxLength: 10000},
                                errors: {
                                    maxLength: TB.trans('validation.max.string', {
                                        'attribute': 'description',
                                        'max': 10000
                                    })
                                }
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default SupplierCertificationForm;

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};